/**
 * @constant Minimum 32-bit signed integer value (-2^31).
 */

    module.exports = -2147483648;




//////////////////
// WEBPACK FOOTER
// ./~/mout/number/MIN_INT.js
// module id = 391
// module chunks = 0 1 2